// extracted by mini-css-extract-plugin
export var chevronIcon = "_3y-2";
export var teamName = "_3y-1";
export var teamSwitcherButton = "_3y-0";